import { Fragment } from 'react'
import {
  TileLayer,
  Marker,
  Popup,
  LayersControl,
  ZoomControl,
} from 'react-leaflet'
import L from 'leaflet'
import '../destination-map-popup.sass'
import { getLanguage } from '../../../utils'
import { getMapTileUrl, isMainLand, tiandituTilesUrl } from 'config'

const language = getLanguage()

export const shopIcon = new L.Icon({
  iconUrl: `${window.staticPath}travel_dist/images/marker.png`,
  iconRetinaUrl: `${window.staticPath}travel_dist/images/marker.png`,
  iconSize: [23, 30],
})

export const hoveredShopIcon = new L.Icon({
  iconUrl: `${window.staticPath}travel_dist/images/marker-violet.png`,
  iconRetinaUrl: `${window.staticPath}travel_dist/images/marker-violet.png`,
  iconSize: [23, 30],
})

export const diveCenterIcon = new L.Icon({
  iconUrl: `${window.staticPath}travel_dist/images/ds-pin.png`,
  iconRetinaUrl: `${window.staticPath}travel_dist/images/ds-pin.png`,
  iconSize: [36, 36],
})

export default function DestinationsMap({
  pins,
  shopTitle,
  shopPin,
  countryCode,
}) {
  const tileUrl = getMapTileUrl({
    isSateliteView: false,
    countryCode: countryCode,
    language,
    isLight: true,
  })

  return (
    <Fragment>
      <LayersControl position='topright'>
        <LayersControl.BaseLayer name='PADI Travel map' checked>
          {isMainLand(countryCode) && <TileLayer url={tiandituTilesUrl} />}
          <TileLayer url={tileUrl} />
        </LayersControl.BaseLayer>
        <LayersControl.BaseLayer name='Satellite'>
          <TileLayer url='//server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}' />
        </LayersControl.BaseLayer>
        <ZoomControl position='topright' />
      </LayersControl>
      <Marker position={[shopPin?.lat, shopPin?.lng]} icon={shopIcon}>
        <Popup className='destination-map-popup'>{shopTitle}</Popup>
      </Marker>
      {pins.map((pin, index) => {
        return (
          <Marker
            key={index}
            position={[pin.latitude, pin.longitude]}
            icon={diveCenterIcon}
          >
            <Popup className='destination-map-popup'>{pin.title}</Popup>
          </Marker>
        )
      })}
    </Fragment>
  )
}
